var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 1.23432C12.4175 0.876823 11.84 0.876823 11.4825 1.23432L7 5.70766L2.5175 1.22516C2.16 0.867656 1.5825 0.867656 1.225 1.22516C0.867504 1.58266 0.867504 2.16016 1.225 2.51766L5.7075 7.00016L1.225 11.4827C0.867504 11.8402 0.867504 12.4177 1.225 12.7752C1.5825 13.1327 2.16 13.1327 2.5175 12.7752L7 8.29266L11.4825 12.7752C11.84 13.1327 12.4175 13.1327 12.775 12.7752C13.1325 12.4177 13.1325 11.8402 12.775 11.4827L8.2925 7.00016L12.775 2.51766C13.1233 2.16932 13.1233 1.58266 12.775 1.23432Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedCancelIcon);
export default __webpack_public_path__ + "static/media/DeprecatedCancelIcon.c527f76a0152101fab258d7c9e117f75.svg";
export { ForwardRef as ReactComponent };